export enum Viewer3DStrategy {
    GeomBased = 0,
    TraceBased = 1,
};